import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

export const roleUserList = createAsyncThunk('roleUser/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'role_user',
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
            },
            headers: {
                'Content-Type': 'application/json',
                Authorization: SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const roleUser = createSlice({
    name: 'roleUser',
    initialState: {
        list: [],
        youCanAssignRoles: {},
        loading: false,
    },
    reducers: {
        clearRoleUser: (state) => {
            state.list = []
            state.youCanAssignRoles = {}
        },
    },
    extraReducers: (builder) => {
        builder.addCase(roleUserList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(roleUserList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                const payload = action.payload.data?.data || {}
                state.list = payload?.list || []
                state.youCanAssignRoles = payload?.youCanAssignRoles || {}
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
                state.youCanAssignRoles = {}
            }
        })
        builder.addCase(roleUserList.rejected, (state) => {
            state.loading = false
            state.list = []
            state.youCanAssignRoles = {}
        })
    },
})

export const { clearRoleUser } = roleUser.actions
export default roleUser.reducer
